'use strict';

const { queryFirst, toggleClass, removeClass, queryAll, hasClass, outerHeight, addClass, throttle, matchesBreakpoint } = require('../domUtil');

const {
    DISPLAY_CLASS,
    HIDDEN_CLASS,
    EVENT_KEY_TAB,
    KEYCODE_TAB,
    EVENT_KEY_ESC,
    KEYCODE_ESCAPE,
    NO_SCROLL_CLASS,
    ANIM_TIME_QUICK_2
} = require('../constants');

const bodyEl = document.body;
const topNav = queryFirst('.page-top-navigation', bodyEl);
const headerEl = queryFirst('.main-header');
const searchMenuEl = queryFirst('.header-search-type', headerEl);
const searchClearBtnEls = queryAll('.search-form-clear', headerEl);
const popularSearchEl = queryFirst('.popular-search', headerEl);
const mainNav = queryFirst('.main-nav', headerEl);
const bannerCloseEl = queryFirst('.close-banner');
const bannerInner = queryFirst('.carousel-stripe-banner');
const noSearchResultsCloseEl = queryFirst('.no-search-results-header .search-form-clear');
const noSearchResultsInput = queryFirst('.no-search-results-header .search-field');
const searchMenuContainer = queryFirst('.search-menu-container-scrollable', headerEl);
const headerSearchInput = queryFirst('.search-field', headerEl);
const showMenuClass = 'open';
const headerMenuShownClass = 'search-open';


let prevScrollPos = window.scrollY;
let initialHeight;

const hideSuggestionsMenu = e => {
    const { target } = e;
    const parentEl = target.closest('.search-global');
    const searchSuggEl = queryFirst('.suggestions-wrapper', parentEl);

    removeClass(searchSuggEl, DISPLAY_CLASS);
    removeClass(popularSearchEl, 'popular-search-with-error');
    addClass(searchSuggEl, HIDDEN_CLASS);
    $('.suggestions').show();
};

const toggleSearchMenu = () => {
    const openingMenu = !hasClass(searchMenuEl, showMenuClass);
    const searchField = queryFirst('.search-field');
    const searchIconButton = queryFirst('.search-toggle-btn-main');

    toggleClass(searchMenuEl, showMenuClass);
    toggleClass(topNav, headerMenuShownClass);

    const ariaValue = searchMenuEl.getAttribute('aria-expanded') !== 'true';
    searchMenuEl.setAttribute('aria-expanded', ariaValue);
    let timeDelay = openingMenu ? 0 : 500;
    initialHeight = window.visualViewport.height;

    setTimeout(() => {
        toggleClass(bodyEl, NO_SCROLL_CLASS);
        if (openingMenu) {
            searchField.focus();
        }
    }, timeDelay);

    // show popular search on opening of search menu, hide search suggestions on close of search menu
    if (openingMenu && popularSearchEl) {
        popularSearchEl.style.display = 'block';
    } else if (!openingMenu) {
        const fullSuggEl = queryFirst('.full-suggestions');
        if (fullSuggEl) {
            fullSuggEl.style.display = 'none';
        }
    }
};

const closeSearchMenu = () => {
    const searchIconButton = queryFirst('.search-toggle-btn-main');
    removeClass(searchMenuEl, showMenuClass);
    removeClass(topNav, headerMenuShownClass);
    $('.suggestions').hide();
    searchMenuEl.setAttribute('aria-expanded', false);
    setTimeout(() => {
        removeClass(bodyEl, NO_SCROLL_CLASS);
        searchIconButton.focus();
        searchIconButton.setAttribute('aria-expanded', 'false');
    }, 400);
};

const handleSearchMenuClose = e => {
    const { target } = e;
    if (target.matches('#search-close') || target.matches('.header-search-type .fade-bg') || target.matches('.header-search-type .search-form-close')) {
        closeSearchMenu();
    }
};

const checkNoResultsInputLength = e => {
    noSearchResultsCloseEl.classList[e.target.value.length ? 'remove' : 'add'](HIDDEN_CLASS);
};

const handleTabListeners = e => {
    const isEscPressed = e.key === EVENT_KEY_ESC || e.keyCode === KEYCODE_ESCAPE;
    if (isEscPressed) {
        closeSearchMenu();
        return;
    }

    const isTabPressed = e.key === EVENT_KEY_TAB || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    const searchField = searchMenuEl.querySelector('.search-field');
    const searchButton = searchMenuEl.querySelector('button[name="search-button"]');
    const resetButton = searchMenuEl.querySelector('button[name="reset-button"]');
    const closeButton = searchMenuEl.querySelector('button.search-form-close');

    const coreElements = [searchField, searchButton, resetButton, closeButton];

    const allPotentialElements = Array.from(
        searchMenuEl.querySelectorAll(
            'button:not([disabled]), [href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
    );

    const otherFocusableElements = allPotentialElements.filter(el => !coreElements.includes(el) && !el.classList.contains('d-md-none') && el.offsetParent !== null);

    const logicalOrder = [
        searchField,
        searchButton,
        (resetButton && resetButton.offsetParent !== null) ? resetButton : null, // Only include reset button if it's visible
        ...otherFocusableElements,
        closeButton
    ].filter(Boolean); // .filter(Boolean) removes any nulls if an element wasn't found.

    if (logicalOrder.length === 0) {
        e.preventDefault();
        return;
    }

    const currentIndex = logicalOrder.indexOf(document.activeElement);

    e.preventDefault();

    const isVisible = el => !!(el.offsetParent || el.getClientRects().length)
        && window.getComputedStyle(el).visibility !== 'hidden'
        && window.getComputedStyle(el).opacity !== '0';

    if (e.shiftKey) {
        const visibleElements = logicalOrder.filter(isVisible);
        const currentVisibleIndex = visibleElements.indexOf(document.activeElement);
        const prevEl = currentVisibleIndex <= 0
            ? visibleElements[visibleElements.length - 1]
            : visibleElements[currentVisibleIndex - 1];

        setTimeout(() => prevEl?.focus(), 0);
    } else {
        const nextIndex = (currentIndex === logicalOrder.length - 1) ? 0 : currentIndex + 1;
        setTimeout(() => logicalOrder[nextIndex].focus(), 0);
    }
};

const adjustHeaderHeight = (homePage) => {
    // Set page-top-navigation height to css variable
    setTimeout(() => {
        const bannerHeight = bannerInner?.getBoundingClientRect().height || 0;

        if (bannerHeight > 0) topNav.style.setProperty('--top-padding', `${bannerHeight}px`);

        if (homePage && hasClass(topNav, 'header-transparent')) {
            const pageTopNavHeight = bannerHeight + headerEl.getBoundingClientRect().height;

            topNav.style.setProperty('--top-nav-height', `-${pageTopNavHeight}px`);
        }
    }, ANIM_TIME_QUICK_2);
};


/**
 * Adjust the height of the search menu container based on the keyboard state.
 * This function detects whether the keyboard is open or closed on mobile devices
 * and adjusts the height of the search menu container accordingly.
 */
const handleKeyboardOpen = () => {
    setTimeout(() => {
        const currentHeight = window.visualViewport.height;
        const keyboardHeight = initialHeight - currentHeight;
        searchMenuContainer.style.setProperty('--keyboard-height', `${keyboardHeight + 50}px`);

        if (currentHeight < initialHeight) {
            // Keyboard is open
            addClass(searchMenuContainer, 'm-keyboard-open');
        }
    }, ANIM_TIME_QUICK_2);
};

module.exports = () => {
    if (!topNav) return; // no need to continue on pages with minified header
    const searchToggles = queryAll('.search-toggle-btn, .search-toggle-btn-main, .try-search-again-btn');
    const homePage = queryFirst('[data-action="Home-Show"]', bodyEl);
    const productPage = queryFirst('[data-action="Product-Show"]', bodyEl);
    const productSetPage = queryFirst('.product-set-detail', bodyEl);

    adjustHeaderHeight(homePage);

    window.addEventListener(
        'resize',
        throttle(() => {
            adjustHeaderHeight(homePage);
        }, 200)
    );

    // Sticky function
    window.addEventListener(
        'scroll',
        throttle(() => {
            // add specific class to header element when user start scrolling
            if (hasClass(headerEl, 'logo-animated')) {
                if (window.scrollY > 10) {
                    if (!hasClass(headerEl, 'm-scrolled')) {
                        addClass(headerEl, 'm-scrolled');
                    }
                } else if (window.scrollY <= 10) {
                    if (hasClass(headerEl, 'm-scrolled')) {
                        removeClass(headerEl, 'm-scrolled');
                    }
                }
            }

            const isStuck = hasClass(headerEl, 'stuck');
            if (window.scrollY > 150 && !isStuck) {
                addClass(headerEl, 'stuck');
            } else if (window.scrollY <= 150 && isStuck) {
                removeClass(headerEl, 'stuck');
            }

            // add specific class to body element when user is scrolling down
            if (window.matchMedia('(max-width: 768px)').matches && productPage && !productSetPage) {
                const currentScrollPos = window.scrollY;

                if (prevScrollPos <= currentScrollPos) {
                    addClass(bodyEl, 'm-pdp-loosed');
                } else {
                    removeClass(bodyEl, 'm-pdp-loosed');
                }

                prevScrollPos = currentScrollPos;
            }
        }, 50)
    );

    // scrollend fires once momentum/inertia scrolling has fully stopped.
    // The leading-edge throttle above can drop the final scroll event when the
    // page comes to rest just below the 10px threshold, leaving m-scrolled stuck.
    // This listener performs a definitive check at the true resting position.
    window.addEventListener('scrollend', () => {
        if (!hasClass(headerEl, 'logo-animated')) return;
        if (window.scrollY <= 10 && hasClass(headerEl, 'm-scrolled')) {
            removeClass(headerEl, 'm-scrolled');
        }
    });

    if (bannerCloseEl) {
        bannerCloseEl.addEventListener('click', () => {
            removeClass(mainNav, 'has-banner');
        });
    }

    searchToggles.forEach(element => {
        element.addEventListener('click', toggleSearchMenu);
    });
    if (searchMenuEl) {
        searchMenuEl.addEventListener('click', handleSearchMenuClose);
    }
    if (searchClearBtnEls) {
        searchClearBtnEls.forEach(btn => {
            btn.addEventListener('click', hideSuggestionsMenu);
        });
    }

    if (noSearchResultsInput) {
        noSearchResultsInput.addEventListener('input', checkNoResultsInputLength);
    }

    if (searchMenuEl) {
        searchMenuEl.addEventListener('keydown', handleTabListeners);
    }

    if (searchMenuContainer && headerSearchInput) {
        headerSearchInput.addEventListener('resize', handleKeyboardOpen);
        headerSearchInput.addEventListener('click', handleKeyboardOpen);
        headerSearchInput.addEventListener('blur', function () {
            removeClass(searchMenuContainer, 'm-keyboard-open');
        });
    }
};
